import { NotificationManager } from 'react-notifications';
import {
  AUTH_TOKEN,
  IS_AUTHENTICATED,
  removeAuthenticatedToken,
  removeIsAuthenticated,
  removeRefreshToken,
  setIsAuthenticated,
} from './cacheStore';
import { isArray } from './lodash';

/**
 * A manager class for user authentication. Sits between calling code
 * and the cache store (local storage).
 */
export const userAuthMgr = {
  isAuthenticated: Boolean(localStorage.getItem(IS_AUTHENTICATED)) || false,
  isAuthToken: Boolean(localStorage.getItem(AUTH_TOKEN)) || false,

  async authenticate(cb) {
    try {
      this.isAuthenticated = true;
      await setIsAuthenticated(true);
    } catch (error) {
      console.error('authenticate -> error', error);
    }

    if (cb) {
      cb();
    }
  },

  async signout() {
    try {
      this.isAuthenticated = false;
      await removeIsAuthenticated();
      await removeAuthenticatedToken();
      await removeRefreshToken();
    } catch (error) {
      console.error('signout -> error', error);
    }
  },
};

export const authMsg = (type, data) => {
  // if error coming from network issue && need to discard error message (no need to  display error message)
  if (data === 'NETWORK_DISCARD') {
    return false;
  }

  let msg;
  let title = null;
  if (isArray(data)) {
    const [message, heading] = data;
    msg = message;
    title = heading;
  } else {
    msg = data;
  }

  if (userAuthMgr.isAuthenticated) {
    switch (type) {
      case 'info':
        NotificationManager.info(msg, title);
        break;
      case 'success':
        NotificationManager.success(msg, title);
        break;
      case 'warning':
        NotificationManager.warning(msg, title);
        break;
      case 'error':
        NotificationManager.error(msg, title);
        break;
      default:
        break;
    }
  } else {
    return false;
  }
};
